import React, { useState } from 'react';
import styles from './styles.module.css';

const Box = props => {
    const {imgSrc,label,onClick}=props;
    const [isHover,setIsHover]=useState(false)
    return (
        <div
        onMouseEnter={()=>{setIsHover(true)}}
        onMouseLeave={()=>{setIsHover(false)}}
        onClick={onClick}
        className={styles.boxContainer}
        style={{borderColor:isHover&&'black',backgroundColor:isHover?'black':'#36454f'}}>
            <div
            style={{borderColor:isHover&&'black',display:'flex', justifyContent:'center'}}>
                <img src={imgSrc}
                style={{height:460,width:440}}
                alt=''/>
            </div>
            <div
            className={styles.text}
            style={{backgroundColor:isHover&&'black'}}>
                {label||''}
            </div>
        </div>
    )
}

export default Box;